module.exports = __webpack_public_path__ + "media/src/admin/images/hour-6548bc0623d611d7572ed296990daa6f.svg";